import AuthAxios from '@/lib/api/axios/AuthAxios'

/**
 * Resends the invitation email for a pending invite
 * @param workspaceSlug - The workspace slug (environment)
 * @param inviteId - The ID of the invitation to resend
 * @throws Error if invitation cannot be resent (not pending or expired)
 */
export async function resendInvite(
  workspaceSlug: string,
  inviteId: string,
): Promise<void> {
  await AuthAxios.post(`/api/v1.0/e/${workspaceSlug}/invites/${inviteId}/resend`)
}
